import type {AssetGalleryAsset} from '@netx/core-asset-gallery/types';
import {type IAsset} from '@netx/core-asset-next/schema';
import {
	allows,
	PermissionMatrixName,
} from '@netx/core-permissions/utils/allows';
import {currentUserMeetsUserLevel} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {MINIMUM_USER_LEVEL} from '../constants';
import {assetExpirationEnabled} from './assetExpirationEnabled';

export const canModifyAssetExpiration = (asset: AssetGalleryAsset | IAsset) =>
	assetExpirationEnabled() &&
	currentUserMeetsUserLevel(MINIMUM_USER_LEVEL) &&
	allows(asset.permissionMatrix, PermissionMatrixName.DELETE);
